import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { LOGIN_ROUTE } from './guards'

export const DASHBOARD_ROUTE = 'dashboard'

/** The screen of an entity that is not built yet: it says so under the title of the route. */
const comingSoon = () => import('@/views/ComingSoonView.vue')

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    // Every page of a logged-in visitor shares one shell and needs a login. Pages load on demand.
    component: () => import('@/layouts/AppLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: { name: DASHBOARD_ROUTE } },
      {
        path: 'dashboard',
        name: DASHBOARD_ROUTE,
        component: () => import('@/views/DashboardView.vue'),
        meta: { title: 'Dashboard' },
      },
      // The screens that the cards of the dashboard lead to (src/data/dashboardCards.ts).
      { path: 'users', name: 'users', component: comingSoon, meta: { title: 'Users' } },
      {
        path: 'organizations',
        name: 'organizations',
        component: comingSoon,
        meta: { title: 'Organizations' },
      },
      {
        path: 'services',
        name: 'services',
        component: () => import('@/views/ServicesView.vue'),
        meta: { title: 'Services' },
      },
    ],
  },
  {
    // A share link: open to anyone, signed in or not, outside the app's shell. The page decides who
    // may see what, with the API.
    path: '/p/:token',
    name: 'shared-page',
    component: () => import('@/views/SharedPageView.vue'),
    meta: { title: 'Shared page' },
  },
  {
    path: '/login',
    component: () => import('@/layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: LOGIN_ROUTE,
        component: () => import('@/views/LoginView.vue'),
        meta: { guestOnly: true, title: 'Log in' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash }
    return { top: 0 }
  },
})

// A page that names itself in its route meta gets "<name> · Dropway" as its title; the others keep the
// title of index.html.
const defaultTitle = document.title
router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} · Dropway` : defaultTitle
})

export default router
